 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import DED from '@/components/ded'
 import CONTENTS from '@/components/contents'
 import BOOK1 from '@/components/book1'
 import PASTORAL_CARE from '@/components/pastoral_care'
 import THE_RAVAGES from '@/components/the_ravages'
 import THE_TEMPTATION from '@/components/the_temptation'
 import THE_WARDEN from '@/components/the_warden'
 import JOHN_NAPPER from '@/components/john_napper'
 import BOOK2 from '@/components/book2'
 import QUEEN_LOUISA from '@/components/queen_louisa'
 import KING_GREGOR from '@/components/king_gregor'
 import MURIEL from '@/components/muriel'
 import BOOK3 from '@/components/book3'
 import BOOK3CH1 from '@/components/book3ch1'
 import BOOK3CH2 from '@/components/book3ch2'
 import LOVE_2 from '@/components/love_2'
 import BIO from '@/components/bio'
 import SELECTED from '@/components/selected'
 import CRT from '@/components/crt'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/book1",
 			"name" : "book1",
 			"component" : BOOK1
 		},
 		{
 			"path" : "/pastoral_care",
 			"name" : "pastoral_care",
 			"component" : PASTORAL_CARE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js